import { getShortUrl } from '@yandex-int/k-common/client/api';
import { Me } from '@yandex-int/k-common/typings';
import b from 'b_';
import { Copy, Checkmark as IconCheckmark } from 'education-icons';
import { Button, Input, Text, Tooltip, Popup } from 'platform-components';
import { POPUP_AXIS, POPUP_DIRECTIONS } from 'platform-components/constants';
import { getMe } from 'platform-components/src/components/user/selectors';
//@ts-ignore
import colors from 'platform-components/src/design/design.scss';
import { withRouterPath, InjectedProps as WithRouterProps } from 'platform-components/hocs';
import { copyTextToClipboard } from 'platform-components/utils';
import PropTypes from 'prop-types';
import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';

import * as selectors from 'common.components/lesson/selectors';
import { LessonStore } from 'common.components/lesson/typings';
import { useTeamRegistrationLink } from 'common.components/user/hooks';

import './side-panel__copy-lesson-link.scss';

interface StoreProps {
    clessonId: number | null;
    courseId: number | null;
    me: Me | null;
}

interface Props extends StoreProps, WithRouterProps {}

export const CopyLessonLink = ({ clessonId, courseId, me }: Props) => {
    const copyLinkPopupRef = useRef<Popup | null>(null);
    const copyLinkRef = useRef<HTMLDivElement | null>(null);
    const [linkCopied, setLinkCopied] = useState(false);
    const [shortLink, setShortLink] = useState('');
    const link = useTeamRegistrationLink() + `?course=${courseId}&lesson=${clessonId}`;

    useEffect(() => {
        async function getShortLinkValue() {
            const shortLinkValue = await getShortUrl(link);
            setShortLink(shortLinkValue);
        }
        getShortLinkValue();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clessonId, courseId]);

    if (!clessonId || !courseId) {
        return null;
    }

    const copyLink = async () => {
        copyTextToClipboard(shortLink);

        if (copyLinkPopupRef && copyLinkPopupRef.current && copyLinkRef && copyLinkRef.current) {
            copyLinkPopupRef.current.setOwner(copyLinkRef.current);
            copyLinkPopupRef.current.show();
            setLinkCopied(true);

            ym('reachGoal', 'teacher_copy_lesson_link', {
                user_id: me?.id,
                clesson_id: clessonId,
                from: 'lesson_statistics_button',
            });
        }
    };

    const showTooltip = () => {
        if (copyLinkPopupRef && copyLinkPopupRef.current && copyLinkRef && copyLinkRef.current) {
            copyLinkPopupRef.current.setOwner(copyLinkRef.current);

            setLinkCopied(false);
            copyLinkPopupRef.current.show();
        }
    };

    const hideTooltip = () => {
        copyLinkPopupRef?.current?.hide();
        setLinkCopied(false);
    };

    return (
        <div className="side-panel__copy-lesson-link-wrapper">
            <Text color={colors.blackCommInit} id="lessonView.sidePanel.linkForStudents" />
            <div className="side-panel__copy-lesson-link">
                <Input mix="side-panel__copy-lesson-link-input" value={shortLink} />
                <Button
                    className="side-panel__copy-lesson-link-btn"
                    icon={<Copy />}
                    onClick={copyLink}
                    onMouseEnter={showTooltip}
                    onMouseLeave={hideTooltip}
                    view={Button.VIEW.CLEAR}
                />
                <div className="side-panel__copy-lesson-link-popup-wrapper" ref={copyLinkRef}>
                    <Tooltip
                        //@ts-ignore TODO: тайпинги для попапа https://st.yandex-team.ru/EDUCATION-11116
                        onPopupRef={copyLinkPopupRef}
                        popupProps={{
                            autoclosable: false,
                            shown: false,
                            axis: POPUP_AXIS.CENTER,
                            offsetTop: -40,
                            direction: POPUP_DIRECTIONS.TOP,
                            mix: 'side-panel__tooltip-on-hover',
                        }}
                    >
                        {linkCopied ? (
                            <div className="side-panel__tooltip-content qa_tooltip-copied">
                                <IconCheckmark className={b('side-panel', 'tooltip-icon', { success: true })} />
                                <Text color={colors.black900} id="lessonView.sidePanel.linkCopied" />
                            </div>
                        ) : (
                            <span className="side-panel__tooltip-content qa_tooltip-to-copy">
                                <Text color={colors.black900} id="lessonView.sidePanel.copyLink" />
                            </span>
                        )}
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};

CopyLessonLink.contextTypes = {
    basePath: PropTypes.string.isRequired,
    prefix: PropTypes.string.isRequired,
    staticUrls: PropTypes.object.isRequired,
};

const mapStateToProps = <T extends LessonStore>(storeState: T): StoreProps => ({
    clessonId: selectors.getCLessonId(storeState),
    courseId: selectors.getLessonCourseId(storeState),
    me: getMe(storeState),
});

const wrapped = withRouterPath(connect(mapStateToProps)(CopyLessonLink));
wrapped.displayName = 'CopyLessonLink';

export default wrapped;
